import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/menu-icons/dashboard/shortage_qty.png'
import _imports_1 from '../../assets/menu-icons/dashboard/account_holder.png'
import _imports_2 from '../../assets/menu-icons/dashboard/expenses.png'
import _imports_3 from '../../assets/menu-icons/dashboard/item_qty.png'
import _imports_4 from '../../assets/menu-icons/dashboard/sales.png'
import _imports_5 from '../../assets/menu-icons/dashboard/sales_qty.png'


const _withScopeId = n => (_pushScopeId("data-v-38367fd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-m-2" }
const _hoisted_2 = { class: "p-grid" }
const _hoisted_3 = { class: "p-col-12 p-mt-2" }
const _hoisted_4 = { class: "p-d-flex p-jc-between" }
const _hoisted_5 = { class: "store-name p-mt-1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-home" }, null, -1))
const _hoisted_7 = { class: "p-grid" }
const _hoisted_8 = {
  class: "p-sm-12 p-lg-2 p-md-2",
  style: {"padding-right":"0 !important"}
}
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "card-body p-p-2" }
const _hoisted_11 = { style: {"float":"left","width":"60%"} }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-1" }, " Shortage Qty ", -1))
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "mt-2 p-mb-2" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "tiles-desc" }, "Items need to import", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"40%","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "dash-icons-style",
    alt: ""
  })
], -1))
const _hoisted_17 = {
  class: "p-sm-12 p-lg-2 p-md-2",
  style: {"padding-right":"0 !important"}
}
const _hoisted_18 = { class: "card" }
const _hoisted_19 = { class: "card-body p-p-2" }
const _hoisted_20 = { style: {"float":"left","width":"60%"} }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-1" }, "Account Holders ", -1))
const _hoisted_22 = { class: "" }
const _hoisted_23 = { class: "mt-2 p-mb-2" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "tiles-desc" }, "All profiles including customers", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"40%","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "dash-icons-style",
    alt: ""
  })
], -1))
const _hoisted_26 = {
  class: "p-sm-12 p-lg-2 p-md-2",
  style: {"padding-right":"0 !important"}
}
const _hoisted_27 = { class: "card" }
const _hoisted_28 = { class: "card-body p-p-2" }
const _hoisted_29 = { style: {"float":"left","width":"60%"} }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-1" }, " Monthly Expense ", -1))
const _hoisted_31 = { class: "" }
const _hoisted_32 = { class: "mt-2 p-mb-2" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "tiles-desc" }, "Expenses via Expense Voucher", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"40%","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "dash-icons-style",
    alt: ""
  })
], -1))
const _hoisted_35 = {
  class: "p-sm-12 p-lg-2 p-md-2",
  style: {"padding-right":"0 !important"}
}
const _hoisted_36 = { class: "card" }
const _hoisted_37 = { class: "card-body p-p-2" }
const _hoisted_38 = { style: {"float":"left","width":"60%"} }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-1" }, " Items Qty ", -1))
const _hoisted_40 = { class: "" }
const _hoisted_41 = { class: "mt-2 p-mb-2" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "tiles-desc" }, "No of items in stock", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"40%","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    class: "dash-icons-style",
    alt: ""
  })
], -1))
const _hoisted_44 = {
  class: "p-sm-12 p-lg-2 p-md-2",
  style: {"padding-right":"0 !important"}
}
const _hoisted_45 = { class: "card" }
const _hoisted_46 = { class: "card-body p-p-2" }
const _hoisted_47 = { style: {"float":"left","width":"60%"} }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-1" }, " Sales Today ", -1))
const _hoisted_49 = { class: "" }
const _hoisted_50 = { class: "mt-2 p-mb-2" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "tiles-desc" }, "Amount of pos sales ", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"40%","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    class: "dash-icons-style",
    alt: ""
  })
], -1))
const _hoisted_53 = { class: "p-sm-12 p-lg-2 p-md-2" }
const _hoisted_54 = { class: "card" }
const _hoisted_55 = { class: "card-body p-p-2" }
const _hoisted_56 = { style: {"float":"left","width":"60%"} }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-1" }, " Sales Qty ", -1))
const _hoisted_58 = { class: "" }
const _hoisted_59 = { class: "mt-2 p-mb-2" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "tiles-desc" }, "No of pos sales ", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"40%","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    class: "dash-icons-style",
    alt: ""
  })
], -1))
const _hoisted_62 = { class: "p-grid" }
const _hoisted_63 = { class: "p-col-12" }
const _hoisted_64 = { class: "card" }
const _hoisted_65 = { class: "card-header" }
const _hoisted_66 = { class: "card-body p-p-1" }
const _hoisted_67 = { class: "p-grid" }
const _hoisted_68 = { class: "p-md-8 p-sm-12 p-lg-8 p-p-0" }
const _hoisted_69 = {
  class: "p-md-6 p-sm-12 p-lg-6",
  style: {"float":"left"}
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " SALES TODAY ", -1))
const _hoisted_71 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_72 = { class: "weekly" }
const _hoisted_73 = {
  class: "p-md-6 p-sm-12 p-lg-6",
  style: {"float":"left"}
}
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " RETURN TODAY ", -1))
const _hoisted_75 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_76 = { class: "weekly" }
const _hoisted_77 = {
  class: "p-md-6 p-sm-12 p-lg-6",
  style: {"float":"left"}
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " EXPENSE TODAY ", -1))
const _hoisted_79 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_80 = { class: "weekly" }
const _hoisted_81 = {
  class: "p-md-6 p-sm-12 p-lg-6",
  style: {"float":"left"}
}
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " PURCHASE TODAY ", -1))
const _hoisted_83 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_84 = { class: "weekly" }
const _hoisted_85 = {
  class: "p-md-6 p-sm-12 p-lg-6",
  style: {"float":"left"}
}
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " PURCHASE RETURN TODAY ", -1))
const _hoisted_87 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_88 = { class: "weekly" }
const _hoisted_89 = {
  class: "p-md-6 p-sm-12 p-lg-6",
  style: {"float":"left"}
}
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " TRANSFER TODAY ", -1))
const _hoisted_91 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_92 = { class: "weekly" }
const _hoisted_93 = {
  class: "p-md-6 p-sm-12 p-lg-6",
  style: {"float":"left"}
}
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " CASH IN TODAY ", -1))
const _hoisted_95 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_96 = { class: "weekly" }
const _hoisted_97 = {
  class: "p-md-6 p-sm-12 p-lg-6",
  style: {"float":"left"}
}
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " CASH AT BANK TODAY ", -1))
const _hoisted_99 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_100 = { class: "weekly" }
const _hoisted_101 = {
  class: "p-md-4 p-sm-12 p-lg-4",
  style: {"padding":"0.5rem 0.2rem !important"}
}
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-plus-circle" }),
  /*#__PURE__*/_createTextVNode(" Recently Added Items")
], -1))
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, "No records found", -1))
const _hoisted_104 = { class: "p-grid" }
const _hoisted_105 = { class: "p-md-4 p-lg-4 p-sm-12 chart-style" }
const _hoisted_106 = { class: "p-p-0" }
const _hoisted_107 = { class: "p-md-4 p-lg-4 p-sm-12 chart-style" }
const _hoisted_108 = { class: "p-md-4 p-lg-4 p-sm-12 chart-style" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Chart = _resolveComponent("Chart")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createTextVNode(" " + _toDisplayString(_ctx.branchName), 1)
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.branchID,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.branchID) = $event)),
              options: _ctx.stores,
              optionLabel: "name",
              optionValue: "id",
              placeholder: "Select a Store",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getHomepageDetails()))
            }, null, 8, ["modelValue", "options"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("h4", _hoisted_14, "# " + _toDisplayString(_ctx.dashInfo.shortageQty), 1),
                _hoisted_15
              ])
            ]),
            _hoisted_16
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("h4", _hoisted_23, "# " + _toDisplayString(_ctx.dashInfo.accountHolders), 1),
                _hoisted_24
              ])
            ]),
            _hoisted_25
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("h4", _hoisted_32, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.monthlyExpense)), 1),
                _hoisted_33
              ])
            ]),
            _hoisted_34
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("h4", _hoisted_41, "# " + _toDisplayString(_ctx.dashInfo.itemsQty), 1),
                _hoisted_42
              ])
            ]),
            _hoisted_43
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _hoisted_48,
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("h4", _hoisted_50, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.salesToday)), 1),
                _hoisted_51
              ])
            ]),
            _hoisted_52
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("div", _hoisted_56, [
              _hoisted_57,
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("h4", _hoisted_59, "# " + _toDisplayString(_ctx.dashInfo.salesQty), 1),
                _hoisted_60
              ])
            ]),
            _hoisted_61
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_62, [
      _createElementVNode("div", _hoisted_63, [
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("h5", null, " (" + _toDisplayString(_ctx.currency) + ") Over All Revenue vs Expense vs Profit (Last 7 Months) ", 1)
          ]),
          _createElementVNode("div", _hoisted_66, [
            _createVNode(_component_Chart, {
              type: "line",
              data: _ctx.multiAxisData,
              options: _ctx.multiAxisOptions,
              height: 100
            }, null, 8, ["data", "options"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_67, [
      _createElementVNode("div", _hoisted_68, [
        _createElementVNode("div", _hoisted_69, [
          _createVNode(_component_Card, null, {
            title: _withCtx(() => [
              _hoisted_70
            ]),
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.salesToday)), 1),
                _createElementVNode("div", _hoisted_72, "Month " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.salesMonth)), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_73, [
          _createVNode(_component_Card, null, {
            title: _withCtx(() => [
              _hoisted_74
            ]),
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.returnToday)), 1),
                _createElementVNode("div", _hoisted_76, "Month " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.returnMonth)), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_77, [
          _createVNode(_component_Card, null, {
            title: _withCtx(() => [
              _hoisted_78
            ]),
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.expenseToday)), 1),
                _createElementVNode("div", _hoisted_80, "Month " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.monthlyExpense)), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_81, [
          _createVNode(_component_Card, null, {
            title: _withCtx(() => [
              _hoisted_82
            ]),
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_83, [
                _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.purchaseToday)), 1),
                _createElementVNode("div", _hoisted_84, "Month " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.purchaseMonth)), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_85, [
          _createVNode(_component_Card, null, {
            title: _withCtx(() => [
              _hoisted_86
            ]),
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_87, [
                _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.purchaseReturnToday)), 1),
                _createElementVNode("div", _hoisted_88, "Month " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.purchaseReturnMonth)), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_89, [
          _createVNode(_component_Card, null, {
            title: _withCtx(() => [
              _hoisted_90
            ]),
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_91, [
                _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.transferToday)), 1),
                _createElementVNode("div", _hoisted_92, "Month " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.transferMonth)), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_93, [
          _createVNode(_component_Card, null, {
            title: _withCtx(() => [
              _hoisted_94
            ]),
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_95, [
                _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.cashInToday)), 1),
                _createElementVNode("div", _hoisted_96, "Month " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.cashInMonth)), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_97, [
          _createVNode(_component_Card, null, {
            title: _withCtx(() => [
              _hoisted_98
            ]),
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_99, [
                _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.cashAtBankToday)), 1),
                _createElementVNode("div", _hoisted_100, "Month " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.cashAtBankMonth)), 1)
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_101, [
        _hoisted_102,
        _createVNode(_component_DataTable, {
          value: _ctx.recentlyItems,
          class: "p-datatable-sm p-datatable-striped p-datatable-gridlines"
        }, {
          empty: _withCtx(() => [
            _hoisted_103
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "qty",
              header: "Units"
            }),
            _createVNode(_component_Column, {
              field: "productName",
              header: "Item Name"
            }),
            _createVNode(_component_Column, {
              field: "mrp",
              header: "MRP"
            })
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ]),
    _createElementVNode("div", _hoisted_104, [
      _createElementVNode("div", _hoisted_105, [
        _createElementVNode("h5", _hoisted_106, "(" + _toDisplayString(_ctx.currency) + ") Top Brands Monthly", 1),
        _createVNode(_component_Chart, {
          type: "bar",
          data: _ctx.brandChartData,
          options: _ctx.storeActivityChartOptions,
          height: 220
        }, null, 8, ["data", "options"])
      ]),
      _createElementVNode("div", _hoisted_107, [
        _createElementVNode("h5", null, "(" + _toDisplayString(_ctx.currency) + ") Top Customers Monthly", 1),
        _createVNode(_component_Chart, {
          type: "bar",
          data: _ctx.customersChart,
          options: _ctx.storeActivityChartOptions,
          height: 220
        }, null, 8, ["data", "options"])
      ]),
      _createElementVNode("div", _hoisted_108, [
        _createElementVNode("h5", null, "(" + _toDisplayString(_ctx.currency) + ") Top Users Monthly", 1),
        _createVNode(_component_Chart, {
          type: "bar",
          data: _ctx.usersChart,
          options: _ctx.storeActivityChartOptions,
          height: 220
        }, null, 8, ["data", "options"])
      ])
    ])
  ]))
}